import Api from "@/services/api";
import { TagTypeEnum, Tag } from "@/services/tags/types";

export async function getTags(tag: TagTypeEnum): Promise<Tag[]> {
    return new Promise((resolve, reject) => {
        Api.get(`/Tags/${tag}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
